<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isActivityDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" />
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Activity-edit',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_ACTIVITY',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/activity/activityUpdate',
      formAddUrl: '/modules/activity/activityAdd',
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '提交', key: 'ADD', action: 'ADD', className: 'primary', hidden: this.componentType !== 'add' },
          { name: '提交', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '基本信息',
        elements: [
          { name: '标题',
            key: 'title',
            type: 'text',
            disabled: false,
            required: true,
            rules: [
              { min: 1, max: 50, message: '标题长度不能超过50', trigger: 'blur' }
            ] },
          { name: '图片', key: 'coverPathList', type: 'image', required: true, disabled: false, limit: 1, markText: '上传图片尺寸750x1200px' }]
      }
    }
  },
  created() {
    if (this.componentType === 'edit') {
      this.detailFormData.coverPathList = [{ fileUrl: this.detailFormData.coverPath }]
    }
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      } else if (item.action === 'ADD') {
        this.onAdd()
      } else if (item.action === 'EDIT') {
        this.onSave()
      }
    },
    onAdd() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestAddActivityDetail()
      }).catch(() => {
      })
    },
    onSave() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUpdateActivityDetail()
      }).catch(() => {
      })
    },
    /*  ------------------------- 网络请求  -------------------------  */
    requestAddActivityDetail() {
      const that = this
      this.detailFormData.type = 2
      const sendData = JSON.parse(JSON.stringify(this.detailFormData))
      sendData.coverPath = this.detailFormData.coverPathList[0].fileUrl

      this.$wtUtil.postFormData({
        url: this.formAddUrl,
        formData: sendData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        this.$emit('on-dialog-action', 'refresh')
      })
    },
    requestUpdateActivityDetail() {
      const that = this
      this.detailFormData.type = 2
      const sendData = JSON.parse(JSON.stringify(this.detailFormData))
      sendData.coverPath = this.detailFormData.coverPathList[0].fileUrl
      this.$wtUtil.postFormData({
        url: this.formUpdateUrl,
        formData: sendData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        this.$emit('on-dialog-action', 'refresh')
      })
    },
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      isActivityDetailLoading: state => state.activity.isActivityDetailLoading,
      detailFormData: state => state.activity.activityDetailData
    })
  }
}
</script>

<style scoped>

</style>
